import * as yup from "yup";

export const privacySettingSchema = yup.object().shape({
    emailPrivacy: yup.string().required('This is a required field.').min(1),
    dobPrivacy: yup.string().required('This is a required field.').min(1),
    addressPrivacy: yup.string().required('This is a required field.').min(1),
    userCanChat: yup.string().required('This is a required field.').min(1),
    groupUserCanChat: yup.string().required('This is a required field.').min(1)
}).required();
